import { IContentfulRichText } from 'api/contentful/contentful.types'
import { FC } from 'react'
import { Text } from 'components/Typography'
import { Spacer } from 'components/spacer/Spacer'
import { ContentfulContent } from 'components/content/contentfulContent/ContentfulContent'
import styled from '@emotion/styled'
import { BLOCKS } from '@contentful/rich-text-types'

type Props = {
  statisticsTitle?: string
  statistics?: {
    title?: string
    value?: string
    description?: IContentfulRichText
  }[]
}

export const BusinessStatistics: FC<Props> = ({ statisticsTitle, statistics }) => {
  if (!statistics || statistics.length === 0) {
    return null
  }

  return (
    <SContainer>
      <STitleContainer>
        <STitle variant="subtitleBold" css={{ textAlign: 'center', fontSize: 32 }}>
          {statisticsTitle}
        </STitle>
      </STitleContainer>
      <Spacer size={4} />
      <SStatisticsGrid>
        {statistics?.map((stat) => (
          <SStatistic key={stat.title}>
            <SValue variant="bodyLargeBold">{stat.value}</SValue>
            <STitle variant="bodyBold" css={{ textTransform: 'uppercase' }}>
              {stat.title}
            </STitle>
            <ContentfulContent
              data={stat.description}
              css={{ margin: 1.5 }}
              components={{
                [BLOCKS.PARAGRAPH]: <Text variant="bodySmall" style={{ marginTop: '0.5rem' }} />,
              }}
            />
          </SStatistic>
        ))}
      </SStatisticsGrid>
    </SContainer>
  )
}

const SContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`

const SStatisticsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 2rem;
  width: 100%;
  margin: 2.5rem auto;

  @media (min-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

const SStatistic = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 0rem;
`

const STitleContainer = styled.div`
  display: flex;
  justify-content: center;
`
const SValue = styled(Text)`
  font-size: 2.5rem;
  font-weight: 600;
  color: var(--color-primary);
  border-bottom: 8px solid #0a82c9;
`

const STitle = styled(Text)`
  margin-top: 0.5rem;
  color: var(--color-primary);
`
